import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isMobile, isTablet } from 'shared/utils/device/screen';
import { getInstance } from 'shared/selectors/app-settings';
import { isEditorViewMode } from 'shared/selectors/wix-sdk';

import VideoPreview from './video-preview/video-preview';
import ImageCover from './image-cover/image-cover';


@connect(store => ({
  instance: getInstance(store),
  isEditorViewMode: isEditorViewMode(),
  isMobileDevice: isMobile() || isTablet(),
}))
class ChannelCover extends React.Component {

  static propTypes = {
    channelId: PropTypes.string,
    instance: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    posterUrl: PropTypes.string,
    mediaInfo: PropTypes.object,
    isEditorViewMode: PropTypes.bool,
    isMobileDevice: PropTypes.bool,
    showVideoCover: PropTypes.bool,
  };

  shouldRenderVideoPreview() {
    const { isEditorViewMode, isMobileDevice } = this.props;
    return this.isVideoPreview() && !isEditorViewMode && !isMobileDevice;
  }

  isVideoPreview() {
    const { showVideoCover, mediaInfo } = this.props;
    return Boolean(showVideoCover && mediaInfo);
  }

  getImageCover() {
    const { width, height, posterUrl } = this.props;

    return (
      <ImageCover posterUrl={posterUrl}
                  dataHook="image-cover"
                  width={width}
                  height={height} />
    );
  }

  render() {
    const { width, height, channelId, instance } = this.props;

    if (this.shouldRenderVideoPreview()) {
      return (
        <VideoPreview dataHook="video-preview"
                      channelId={channelId}
                      instance={instance}
                      fallbackComponent={this.getImageCover()}
                      width={width}
                      height={height} />
      );
    }

    return this.getImageCover();
  }
}


export default ChannelCover;



// WEBPACK FOOTER //
// ./src/widget/containers/channel-cover/channel-cover.js